module.exports = "@media only screen and (min-width: 993px) {\n  .container {\n    width: 35%; } }\n"